import { AuthService } from './authService';
import { extractApiError } from '../utils/apiError';
import { SystemSetupSSCCDto, UpdateSystemSetupSSCCRequest } from '../types/systemSetupSscc';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class SystemSetupSsccService {
  private baseUrl = `${API_BASE_URL}/system-setup-sscc`;

  /**
   * Henter SSCC-konfigurasjonen for gjeldende firma.
   * Returnerer null hvis ikke konfigurert (HTTP 204).
   */
  async getCurrent(): Promise<SystemSetupSSCCDto | null> {
    const response = await AuthService.authenticatedGet(`${this.baseUrl}/current`);
    if (response.status === 204) {
      return null;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  }

  /**
   * Oppretter/oppdaterer SSCC-konfigurasjonen for gjeldende firma.
   */
  async save(request: UpdateSystemSetupSSCCRequest): Promise<SystemSetupSSCCDto> {
    const response = await AuthService.authenticatedPut(`${this.baseUrl}`, request);
    if (!response.ok) {
      const error = await response.json().catch(() => null);
      throw new Error(extractApiError(error, response, 'HTTP error!'));
    }
    return await response.json();
  }
}

export const systemSetupSsccService = new SystemSetupSsccService();
